var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Button, Text, tokens } from '@fluentui/react-components';
import AppBarIcons from '@office-start/appbar-icons';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { getIsMobile } from '@office-start/device-detection-utility';
import { useLocStrings } from '@office-start/loc-service';
import React, { useCallback, useEffect, useState } from 'react';
import { useMobileWebBottomBarstyles } from '../MobileWebPage/MobileBottomNavBar.styles';
var MobileBottomNavBar = function () {
    var _a, _b, _c;
    var _d = __read(useState(false), 2), isMobile = _d[0], setIsMobile = _d[1];
    useEffect(function () {
        var handleResize = function () {
            setIsMobile(getIsMobile());
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var context = useOfficeComponentContext().data;
    var mobileWebBottomBarStyles = useMobileWebBottomBarstyles();
    var locStrings = useLocStrings().data;
    // Callback function to navigate to the home page
    var navigateToHomePage = useCallback(function () {
        if (context === null || context === void 0 ? void 0 : context.router) {
            context.router.navigateTo({
                route: 'OfficeHome',
            });
        }
        else {
            console.error('Router is not available in the context');
        }
    }, [context]);
    // Return null if not on a mobile device
    if (!isMobile) {
        return null;
    }
    // Check if the current route is 'OfficeHome'
    var isHomeSelected = ((_a = context === null || context === void 0 ? void 0 : context.router.getCurrentRoute()) === null || _a === void 0 ? void 0 : _a.route) === 'OfficeHome';
    var primaryFillColor = isHomeSelected
        ? tokens.colorNeutralForeground3BrandSelected
        : tokens.colorNeutralForeground3;
    return (React.createElement("div", { className: mobileWebBottomBarStyles.bottomNav },
        React.createElement(Button, { className: mobileWebBottomBarStyles.buttonIcon, onClick: navigateToHomePage, icon: isHomeSelected ? (React.createElement(AppBarIcons.HomeIconSelected, { color: primaryFillColor })) : (React.createElement(AppBarIcons.HomeIcon, { color: primaryFillColor })) }),
        React.createElement(Text, { className: mobileWebBottomBarStyles.buttonText, style: { color: primaryFillColor } }, (_c = (_b = locStrings === null || locStrings === void 0 ? void 0 : locStrings.authPageResources) === null || _b === void 0 ? void 0 : _b.homePageTitle) !== null && _c !== void 0 ? _c : 'Home')));
};
export default MobileBottomNavBar;
//# sourceMappingURL=MobileBottomNavBar.js.map